import { Outlet } from "react-router-dom";
import classes from "./Header.module.css";
import { HashLink } from "react-router-hash-link";

const Header = ({ afterAnime }) => {
    return (
        <>
            <header
                className={`${classes.headerContainer} ${
                    !afterAnime ? classes.headerAnime : ""
                }`}
            >
                <div className={classes.headerLeftBox}>
                    <HashLink className={classes.headerName} to='/#hero'>
                        KAORI ERA
                    </HashLink>
                    <HashLink
                        className={classes.headerSkills}
                        to='/#skills'
                        offset='-40'
                    >
                        SKILLS
                    </HashLink>
                    <HashLink
                        className={classes.headerProjects}
                        to='/#projects'
                        // offset='60'
                    >
                        PROJECTS
                    </HashLink>
                </div>
            </header>
            <Outlet />
        </>
    );
};

export default Header;
